import './Services/deviareAuth';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { StylesProvider } from '@material-ui/core/styles';
import { KeycloakProvider } from '../src/Context/keyCloakProvider';
import { applyColorMode, getColorMode } from './theme/colorMode';
import generateStableClassName from './theme/generateClassName';

applyColorMode(getColorMode());

const generateClassName = generateStableClassName();

ReactDOM.render(
  <StylesProvider generateClassName={generateClassName}>
    <KeycloakProvider>
      <App />
    </KeycloakProvider>
  </StylesProvider>,
  document.getElementById('root')
);
 
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();